import { useCallback, useContext, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { ToastContext, useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

import { searchOrdersDebounceMs } from './constants'
import { transformResponseOrderTrackingPreviewOrders } from './transformers'

const useRealOrderSearch = ({ storeId }) => {
  const { t } = useTranslation()
  const { setToastInfo } = useContext(ToastContext)
  const debounceRef = useRef(null)

  const { data, loading, fetchDataCancellable } = useFetch(configurationServices.getOrderTrackingPreviewOrders, {
    doInitialRequest: false,
    transformResponse: transformResponseOrderTrackingPreviewOrders,
  })

  const handleSearchError = useCallback(() => {
    setToastInfo({ show: true, message: t('No se han podido cargar los pedidos. Inténtalo de nuevo.'), type: 'error' })
  }, [setToastInfo, t])

  useEffect(() => {
    fetchDataCancellable({ storeId, search: '' }, undefined, handleSearchError)

    return () => clearTimeout(debounceRef.current)
  }, [storeId, fetchDataCancellable, handleSearchError])

  const searchOrders = search => {
    clearTimeout(debounceRef.current)

    debounceRef.current = setTimeout(() => {
      fetchDataCancellable({ storeId, search }, undefined, handleSearchError)
    }, searchOrdersDebounceMs)
  }

  return { orders: data, searchingOrders: loading, searchOrders }
}

export default useRealOrderSearch
